// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input:focus {
  outline: none;
  box-shadow: none;
  border: 1px solid rgba(238, 58, 36, 0.8);
}

.MuiFormControl-root input:focus {
  outline: none;
  box-shadow: none;
  border: none;
}

.navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper {
  max-width: 44.59vw;
  width: 100%;
  box-shadow: -5px -5px 250px 0px rgba(255, 255, 255, 0.0196078431);
  background: radial-gradient(100% 100% at 0% 0%, rgba(53, 38, 38, 0.4) 0%, rgba(38, 26, 26, 0.1) 100%);
  backdrop-filter: blur(42px);
}
.navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper .navigation-instruction-container {
  margin: 2.85vw 3.53vw;
}
.navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper .navigation-instruction-container h3 {
  font-weight: 700;
  text-align: center;
  color: #ffffff;
  font-size: 1.41vw;
  line-height: 2.18vw;
}
.navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper .navigation-instruction-container .navigation-instruction-wrapper {
  display: flex;
  margin-top: 1.95vw;
  justify-content: space-between;
}
.navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper .navigation-instruction-container .navigation-instruction-wrapper hr {
  color: #d9d9d9;
  height: 141.8px;
}
.navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper .navigation-instruction-container .navigation-instruction-wrapper .keys-instruction {
  padding: 0 3.33vw 0 1.11vw;
}
.navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper .navigation-instruction-container .navigation-instruction-wrapper .keys-instruction .instruction-text {
  font-weight: 700;
  color: #ffffff;
  font-size: 0.88vw;
  line-height: 1.07vw;
  margin-top: 1.11vw;
}
.navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper .navigation-instruction-container .navigation-instruction-wrapper .click-drag {
  padding: 0 1.9vw;
  text-align: center;
}
.navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper .navigation-instruction-container .navigation-instruction-wrapper .click-drag p {
  font-weight: 500;
  text-align: center;
  color: #ffffff;
  font-size: 0.88vw;
  line-height: 1.07vw;
  margin-top: 1.11vw;
}
.navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper .navigation-instruction-container .navigation-instruction-wrapper .double-click {
  padding: 0 0 0 1.65vw;
  text-align: center;
}
.navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper .navigation-instruction-container .navigation-instruction-wrapper .double-click p {
  font-weight: 500;
  text-align: center;
  color: #ffffff;
  font-size: 0.88vw;
  line-height: 1.07vw;
  margin-top: 1.11vw;
}
.navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper .enter-btn {
  text-align: center;
  border: none;
  position: relative;
  top: 0.55vw;
  left: 0.6255vw;
  margin: 1.11vw 0 2vw;
}
.navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper button {
  font-weight: 400;
  text-align: center;
  cursor: pointer;
  color: #3f3636;
  font-size: 1.25vw;
  line-height: 1.25vw;
  padding: 1.11vw 4.44vw;
  background-color: #ffffff;
  border: none;
}
.navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper .want-to-pay-game-container {
  margin: 0 3.53vw;
}
.navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper .want-to-pay-game-container h3 {
  font-weight: 700;
  text-align: center;
  color: #ffffff;
  font-size: 1.41vw;
  line-height: 2.18vw;
}
.navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper .want-to-pay-game-container .navigation-instruction-wrapper {
  width: 100%;
}
.navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper .want-to-pay-game-container .navigation-instruction-wrapper input {
  padding: 1.65vw 1.11vw;
  max-width: calc(100% - 3.53vw);
  width: 100%;
  margin: 1.11vw 0 0 0;
  border-radius: 1px;
  border: 1px solid #ffffff;
  background: transparent;
  color: #ffffff;
  font-size: 14px;
}
.navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper .want-to-pay-game-container .navigation-instruction-wrapper input::placeholder {
  font-size: 14px;
  font-weight: 500;
  color: #e1e1e1;
  letter-spacing: 2%;
  line-height: 1.49vw;
}
.navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper .want-to-pay-game-container .terms-condition {
  text-align: left;
  display: flex;
  align-items: center;
  margin: 0.55vw 0 1.11vw 0;
}
.navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper .want-to-pay-game-container .terms-condition > span:first-child {
  padding: 0;
}
.navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper .want-to-pay-game-container .terms-condition > span:first-child input[type=checkbox] {
  width: 100%;
  height: 100%;
  cursor: pointer;
  color: #ffffff;
}
.navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper .want-to-pay-game-container .terms-condition > span:first-child svg {
  fill: #ffffff;
}
.navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper .want-to-pay-game-container .terms-condition > span:last-child {
  font-size: 1.11vw;
  color: #ffffff;
  font-weight: 400;
  line-height: 1.3209vw;
  letter-spacing: 2%;
  margin-left: 1.11vw;
}
.navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper .want-to-pay-game-container .terms-condition > span:last-child a {
  font-weight: 600;
  color: #ffffff;
  text-decoration: underline;
  text-underline-offset: 0.2775vw;
}
.navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper .want-to-pay-game-container .discount-code {
  font-size: 1.25vw;
  font-weight: 500;
  color: #ffffff;
  letter-spacing: 2%;
  line-height: 1.49vw;
  text-align: center;
  margin: 1.11vw 0 1.65vw 0;
}
.navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper .want-to-pay-game-container .code-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #ffffff;
  margin: 1.11vw 0 3.88vw 0;
}
.navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper .want-to-pay-game-container .code-container p {
  padding: 1.25vw 0 1.25vw 0;
  margin: auto;
  color: #e1e1e1;
  font-size: 1.25vw;
  font-weight: 700;
  line-height: 1.25vw;
}
.navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper .want-to-pay-game-container .code-container div {
  position: relative;
  right: 1.65vw;
}

.navigation-instruction-dialog .MuiBackdrop-root {
  opacity: 0 !important;
}

.close {
  display: flex;
  justify-content: end;
  position: relative;
  right: 1.11vw;
}
.close .close-icon {
  background: radial-gradient(100% 100% at 0% 0%, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0.81) 100%);
  box-shadow: -5px -5px 250px 0px rgba(255, 255, 255, 0.0196078431) inset;
  margin-top: 1.11vw;
  width: 2.775vw;
  height: 2.775vw;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.lostmessage-dialog .MuiPaper-root.MuiDialog-paper {
  max-width: 52.03vw;
  width: 100%;
  box-shadow: -5px -5px 250px 0px rgba(255, 255, 255, 0.0196078431);
  background: radial-gradient(100% 100% at 0% 0%, rgba(53, 38, 38, 0.4) 0%, rgba(38, 26, 26, 0.1) 100%);
  backdrop-filter: blur(42px);
}
.lostmessage-dialog .MuiPaper-root.MuiDialog-paper .want-to-pay-game-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
.lostmessage-dialog .MuiPaper-root.MuiDialog-paper .want-to-pay-game-container .want-to-pay-game-wrapper {
  margin: 2.22vw 4.44vw;
}
.lostmessage-dialog .MuiPaper-root.MuiDialog-paper .want-to-pay-game-container .want-to-pay-game-wrapper h3 {
  font-weight: 700;
  text-align: center;
  color: #ffffff;
  font-size: 1.41vw;
  line-height: 2.18vw;
}
.lostmessage-dialog .MuiPaper-root.MuiDialog-paper .want-to-pay-game-container .want-to-pay-game-wrapper .try-again {
  font-size: 1.39vw;
  line-height: 1.91vw;
  color: #ffffff;
  font-weight: 400;
  text-align: center;
  margin-bottom: 3.33vw;
}
.lostmessage-dialog .MuiPaper-root.MuiDialog-paper .game-rules-container .game-rules-wrapper h3 {
  font-weight: 700;
  text-align: center;
  color: #ffffff;
  font-size: 1.41vw;
  line-height: 2.18vw;
}
.lostmessage-dialog .MuiPaper-root.MuiDialog-paper .game-rules-container .game-rules-wrapper .ans-text {
  font-size: 1.25vw;
  line-height: 1.49vw;
  color: #ffffff;
  font-weight: 500;
  letter-spacing: 2%;
  text-align: center;
  margin: 1.11vw 0;
}
.lostmessage-dialog .MuiPaper-root.MuiDialog-paper .game-rules-container .game-rules-wrapper .enter-btn {
  text-align: center;
  border: none;
  position: relative;
  margin: 2.22vw 0 3.33vw 0;
}
.lostmessage-dialog .MuiPaper-root.MuiDialog-paper .game-rules-container .game-rules-wrapper button {
  font-weight: 400;
  text-align: center;
  cursor: pointer;
  color: #3f3636;
  font-size: 1.25vw;
  line-height: 1.25vw;
  padding: 1.11vw 4.44vw;
  background-color: #ffffff;
  border: none;
}

.quiz-dialog .MuiPaper-root.MuiDialog-paper {
  max-width: 27.06vw;
  width: 100%;
  box-shadow: -5px -5px 250px 0px rgba(255, 255, 255, 0.0196078431);
  background: radial-gradient(100% 100% at 0% 0%, rgba(53, 38, 38, 0.4) 0%, rgba(38, 26, 26, 0.1) 100%);
  backdrop-filter: blur(42px);
}
.quiz-dialog .MuiPaper-root.MuiDialog-paper .quiz-dialog-container {
  margin: 2.85vw 1.07vw;
}
.quiz-dialog .MuiPaper-root.MuiDialog-paper .quiz-dialog-container .quiz-dialog-wrapper {
  margin-bottom: 1.11vw;
}
.quiz-dialog .MuiPaper-root.MuiDialog-paper .quiz-dialog-container .quiz-dialog-wrapper h4 {
  font-size: 1.25vw;
  font-weight: 500;
  line-height: 1.49vw;
  text-align: center;
  letter-spacing: 2%;
  color: #ffffff;
}
.quiz-dialog .MuiPaper-root.MuiDialog-paper .quiz-dialog-container .quiz-dialog-wrapper .questions-container {
  margin: 1.11vw 4.995vw;
}
.quiz-dialog .MuiPaper-root.MuiDialog-paper .quiz-dialog-container .quiz-dialog-wrapper .questions-container .questions {
  margin: 0.55vw 0;
  border-radius: 2.775vw;
  gap: 0.6938vw;
  padding: 0.55vw 3.33vw;
  border: 1px solid #ffffff;
  background: #ffffff;
}
.quiz-dialog .MuiPaper-root.MuiDialog-paper .quiz-dialog-container .quiz-dialog-wrapper .questions-container .questions p {
  line-height: 1.25vw;
  font-size: 1.25vw;
  color: #3f3636;
  text-align: center;
  font-weight: 400;
}

@media screen and (max-width: 720px) {
  .navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper {
    min-width: none;
    max-width: none;
    width: 480px;
  }
  .navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper .close .close-icon {
    width: 30px;
    height: 30px;
  }
  .navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper .want-to-pay-game-container h3 {
    font-size: 20px;
    line-height: normal;
  }
  .navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper .want-to-pay-game-container h4,
  .navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper .want-to-pay-game-container p {
    font-size: 18px;
    line-height: normal;
  }
  .navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper .want-to-pay-game-container h4 {
    margin: 15px 0;
  }
  .navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper .want-to-pay-game-container .navigation-instruction-wrapper input {
    padding: 10px 15px;
    font-size: 16px;
    line-height: 16px;
    box-sizing: border-box;
    margin: 15px 0;
  }
  .navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper .want-to-pay-game-container .terms-condition > span:last-child {
    font-size: 12px;
  }
  .navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper .try-again {
    margin: 12.5px 0;
  }
  .navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper button {
    font-size: 16px;
    line-height: normal;
    padding: 10px 15px;
    border-radius: 2px;
  }
  .navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper p,
  .navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper button {
    font-size: 16px;
    line-height: normal;
  }
  .navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper .want-to-pay-game-container .discount-code {
    font-size: 16px;
    line-height: 16px;
    margin: 15px 0;
  }
  .navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper .want-to-pay-game-container .code-container p {
    font-size: 16px;
    line-height: 16px;
  }
}
@media screen and (max-width: 480px) {
  .navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper {
    min-width: none;
    max-width: none;
    width: 95%;
    padding: 10px;
    margin: 0 2.5%;
  }
  .navigation-instruction-dialog.isMobile.MuiModal-root .css-19do60a-MuiDialog-container {
    display: flex !important;
    align-items: end !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/style/components/three/game/NavigationInstruction.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,gBAAA;EACA,wCAAA;AACF;;AAEE;EACE,aAAA;EACA,gBAAA;EACA,YAAA;AACJ;;AAGA;EACE,kBAAA;EACA,WAAA;EACA,iEAAA;EACA,qGAAA;EAKA,2BAAA;AAJF;AAME;EACE,qBAAA;AAJJ;AAMI;EACE,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;AAJN;AAQI;EACE,aAAA;EACA,kBAAA;EACA,8BAAA;AANN;AAQM;EACE,cAAA;EACA,eAAA;AANR;AASM;EACE,0BAAA;AAPR;AASQ;EACE,gBAAA;EAEA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AARV;AAYM;EACE,gBAAA;EACA,kBAAA;AAVR;AAYQ;EACE,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AAVV;AAcM;EACE,qBAAA;EACA,kBAAA;AAZR;AAcQ;EACE,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AAZV;AAkBE;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,oBAAA;AAhBJ;AAmBE;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EAEA,sBAAA;EACA,yBAAA;EACA,YAAA;AAlBJ;AAqBE;EACE,gBAAA;AAnBJ;AAqBI;EACE,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;AAnBN;AAuBI;EACE,WAAA;AArBN;AAuBM;EACE,sBAAA;EACA,8BAAA;EACA,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AArBR;AAwBM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAtBR;AA0BI;EACE,gBAAA;EAEA,aAAA;EACA,mBAAA;EACA,yBAAA;AAzBN;AA0BM;EACE,UAAA;AAxBR;AAyBQ;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AAvBV;AAyBQ;EACE,aAAA;AAvBV;AA0BM;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;AAxBR;AA0BQ;EACE,gBAAA;EACA,cAAA;EACA,0BAAA;EACA,+BAAA;AAxBV;AA6BI;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AA3BN;AA8BI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,yBAAA;EACA,yBAAA;AA5BN;AA8BM;EACE,0BAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AA5BR;AA+BM;EACE,kBAAA;EACA,aAAA;AA7BR;;AAmCA;EACE,qBAAA;AAhCF;;AAmCA;EACE,aAAA;EACA,oBAAA;EACA,kBAAA;EACA,aAAA;AAhCF;AAkCE;EACE,4GAAA;EAMA,uEAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AArCJ;;AAyCA;EACE,kBAAA;EACA,WAAA;EAEA,iEAAA;EACA,qGAAA;EAMA,2BAAA;AA5CF;AA8CE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AA5CJ;AA8CI;EACE,qBAAA;AA5CN;AA8CM;EACE,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;AA5CR;AAgDM;EACE,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;AA9CR;AAqDM;EACE,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;AAnDR;AAuDM;EACE,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AArDR;AAwDM;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EAEA,yBAAA;AAvDR;AA0DM;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EAEA,sBAAA;EACA,yBAAA;EACA,YAAA;AAzDR;;AA+DA;EACE,kBAAA;EACA,WAAA;EACA,iEAAA;EACA,qGAAA;EAMA,2BAAA;AAjEF;AAmEE;EACE,qBAAA;AAjEJ;AAmEI;EACE,qBAAA;AAjEN;AAkEM;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;AAhER;AAmEM;EACE,sBAAA;AAjER;AAmEQ;EACE,gBAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;AAjEV;AAmEU;EACE,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAjEZ;;AAyEA;EACE;IACE,eAAA;IACA,eAAA;IACA,YAAA;EAtEF;EAwEE;IACE,WAAA;IACA,YAAA;EAtEJ;EA0EI;IACE,eAAA;IACA,mBAAA;EAxEN;EA2EI;;IAEE,eAAA;IACA,mBAAA;EAzEN;EA2EI;IACE,cAAA;EAzEN;EA4EI;IACE,kBAAA;IACA,eAAA;IACA,iBAAA;IACA,sBAAA;IACA,cAAA;EA1EN;EA8EM;IACE,eAAA;EA5ER;EAqFE;IACE,gBAAA;EAnFJ;EAqFE;IACE,eAAA;IACA,mBAAA;IACA,kBAAA;IACA,kBAAA;EAnFJ;EAsFE;;IAEE,eAAA;IACA,mBAAA;EApFJ;EAuFA;IAIE,eAAA;IACA,iBAAA;IACA,cAAA;EAxFF;EA0FA;IAKE,eAAA;IACA,iBAAA;EA5FF;AACF;AA+FA;EACE;IACE,eAAA;IACA,eAAA;IACA,UAAA;IACA,aAAA;IACA,cAAA;EA7FF;EA+FA;IAEE,wBAAA;IACA,2BAAA;EA9FF;AACF","sourcesContent":["input:focus {\n  outline: none;\n  box-shadow: none;\n  border: 1px solid #ee3a24cc;\n}\n.MuiFormControl-root {\n  input:focus {\n    outline: none;\n    box-shadow: none;\n    border: none;\n  }\n}\n\n.navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper {\n  max-width: 44.59vw;\n  width: 100%;\n  box-shadow: -5px -5px 250px 0px #ffffff05;\n  background: radial-gradient(\n    100% 100% at 0% 0%,\n    rgba(53, 38, 38, 0.4) 0%,\n    rgba(38, 26, 26, 0.1) 100%\n  );\n  backdrop-filter: blur(42px);\n\n  .navigation-instruction-container {\n    margin: 2.85vw 3.53vw;\n\n    h3 {\n      font-weight: 700;\n      text-align: center;\n      color: #ffffff;\n      font-size: 1.41vw;\n      line-height: 2.18vw;\n      // margin-top: 2.85vw;\n    }\n\n    .navigation-instruction-wrapper {\n      display: flex;\n      margin-top: 1.95vw;\n      justify-content: space-between;\n\n      hr {\n        color: #d9d9d9;\n        height: 141.8px;\n      }\n\n      .keys-instruction {\n        padding: 0 3.33vw 0 1.11vw;\n\n        .instruction-text {\n          font-weight: 700;\n\n          color: #ffffff;\n          font-size: 0.88vw;\n          line-height: 1.07vw;\n          margin-top: 1.11vw;\n        }\n      }\n\n      .click-drag {\n        padding: 0 1.9vw;\n        text-align: center;\n\n        p {\n          font-weight: 500;\n          text-align: center;\n          color: #ffffff;\n          font-size: 0.88vw;\n          line-height: 1.07vw;\n          margin-top: 1.11vw;\n        }\n      }\n\n      .double-click {\n        padding: 0 0 0 1.65vw;\n        text-align: center;\n\n        p {\n          font-weight: 500;\n          text-align: center;\n          color: #ffffff;\n          font-size: 0.88vw;\n          line-height: 1.07vw;\n          margin-top: 1.11vw;\n        }\n      }\n    }\n  }\n\n  .enter-btn {\n    text-align: center;\n    border: none;\n    position: relative;\n    top: 0.55vw;\n    left: 0.6255vw;\n    margin: 1.11vw 0 2vw;\n  }\n\n  button {\n    font-weight: 400;\n    text-align: center;\n    cursor: pointer;\n    color: #3f3636;\n    font-size: 1.25vw;\n    line-height: 1.25vw;\n    // margin-top: 2.85vw;\n    padding: 1.11vw 4.44vw;\n    background-color: #ffffff;\n    border: none;\n  }\n\n  .want-to-pay-game-container {\n    margin: 0 3.53vw;\n\n    h3 {\n      font-weight: 700;\n      text-align: center;\n      color: #ffffff;\n      font-size: 1.41vw;\n      line-height: 2.18vw;\n      // margin-top: 2.85vw;\n    }\n\n    .navigation-instruction-wrapper {\n      width: 100%;\n\n      input {\n        padding: 1.65vw 1.11vw;\n        max-width: calc(100% - 3.53vw);\n        width: 100%;\n        margin: 1.11vw 0 0 0;\n        border-radius: 1px;\n        border: 1px solid #ffffff;\n        background: transparent;\n        color: #ffffff;\n        font-size: 14px;\n      }\n\n      input::placeholder {\n        font-size: 14px;\n        font-weight: 500;\n        color: #e1e1e1;\n        letter-spacing: 2%;\n        line-height: 1.49vw;\n      }\n    }\n\n    .terms-condition {\n      text-align: left;\n\n      display: flex;\n      align-items: center;\n      margin: 0.55vw 0 1.11vw 0;\n      & > span:first-child {\n        padding: 0;\n        input[type=\"checkbox\"] {\n          width: 100%;\n          height: 100%;\n          cursor: pointer;\n          color: #ffffff;\n        }\n        svg {\n          fill: #ffffff;\n        }\n      }\n      & > span:last-child {\n        font-size: 1.11vw;\n        color: #ffffff;\n        font-weight: 400;\n        line-height: 1.3209vw;\n        letter-spacing: 2%;\n        margin-left: 1.11vw;\n\n        a {\n          font-weight: 600;\n          color: #ffffff;\n          text-decoration: underline;\n          text-underline-offset: 0.2775vw;\n        }\n      }\n    }\n\n    .discount-code {\n      font-size: 1.25vw;\n      font-weight: 500;\n      color: #ffffff;\n      letter-spacing: 2%;\n      line-height: 1.49vw;\n      text-align: center;\n      margin: 1.11vw 0 1.65vw 0;\n    }\n\n    .code-container {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      border: 1px solid #ffffff;\n      margin: 1.11vw 0 3.88vw 0;\n\n      p {\n        padding: 1.25vw 0 1.25vw 0;\n        margin: auto;\n        color: #e1e1e1;\n        font-size: 1.25vw;\n        font-weight: 700;\n        line-height: 1.25vw;\n      }\n\n      div {\n        position: relative;\n        right: 1.65vw;\n      }\n    }\n  }\n}\n\n.navigation-instruction-dialog .MuiBackdrop-root {\n  opacity: 0 !important;\n}\n\n.close {\n  display: flex;\n  justify-content: end;\n  position: relative;\n  right: 1.11vw;\n\n  .close-icon {\n    background: radial-gradient(\n        100% 100% at 0% 0%,\n        rgba(255, 255, 255, 0.4) 0%,\n        rgba(255, 255, 255, 0.81) 100%\n      )\n      /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;\n    box-shadow: -5px -5px 250px 0px #ffffff05 inset;\n    margin-top: 1.11vw;\n    width: 2.775vw;\n    height: 2.775vw;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n  }\n}\n\n.lostmessage-dialog .MuiPaper-root.MuiDialog-paper {\n  max-width: 52.03vw;\n  width: 100%;\n\n  box-shadow: -5px -5px 250px 0px #ffffff05;\n  background: radial-gradient(\n      100% 100% at 0% 0%,\n      rgba(53, 38, 38, 0.4) 0%,\n      rgba(38, 26, 26, 0.1) 100%\n    )\n    /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;\n  backdrop-filter: blur(42px);\n\n  .want-to-pay-game-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    .want-to-pay-game-wrapper {\n      margin: 2.22vw 4.44vw;\n\n      h3 {\n        font-weight: 700;\n        text-align: center;\n        color: #ffffff;\n        font-size: 1.41vw;\n        line-height: 2.18vw;\n        // margin-top: 2.85vw;\n      }\n\n      .try-again {\n        font-size: 1.39vw;\n        line-height: 1.91vw;\n        color: #ffffff;\n        font-weight: 400;\n        text-align: center;\n        margin-bottom: 3.33vw;\n      }\n    }\n  }\n\n  .game-rules-container {\n    .game-rules-wrapper {\n      h3 {\n        font-weight: 700;\n        text-align: center;\n        color: #ffffff;\n        font-size: 1.41vw;\n        line-height: 2.18vw;\n        // margin-top: 2.85vw;\n      }\n\n      .ans-text {\n        font-size: 1.25vw;\n        line-height: 1.49vw;\n        color: #ffffff;\n        font-weight: 500;\n        letter-spacing: 2%;\n        text-align: center;\n        margin: 1.11vw 0;\n      }\n\n      .enter-btn {\n        text-align: center;\n        border: none;\n        position: relative;\n\n        margin: 2.22vw 0 3.33vw 0;\n      }\n\n      button {\n        font-weight: 400;\n        text-align: center;\n        cursor: pointer;\n        color: #3f3636;\n        font-size: 1.25vw;\n        line-height: 1.25vw;\n        // margin-top: 2.85vw;\n        padding: 1.11vw 4.44vw;\n        background-color: #ffffff;\n        border: none;\n      }\n    }\n  }\n}\n\n.quiz-dialog .MuiPaper-root.MuiDialog-paper {\n  max-width: 27.06vw;\n  width: 100%;\n  box-shadow: -5px -5px 250px 0px #ffffff05;\n  background: radial-gradient(\n      100% 100% at 0% 0%,\n      rgba(53, 38, 38, 0.4) 0%,\n      rgba(38, 26, 26, 0.1) 100%\n    )\n    /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;\n  backdrop-filter: blur(42px);\n\n  .quiz-dialog-container {\n    margin: 2.85vw 1.07vw;\n\n    .quiz-dialog-wrapper {\n      margin-bottom: 1.11vw;\n      h4 {\n        font-size: 1.25vw;\n        font-weight: 500;\n        line-height: 1.49vw;\n        text-align: center;\n        letter-spacing: 2%;\n        color: #ffffff;\n      }\n\n      .questions-container {\n        margin: 1.11vw 4.995vw;\n\n        .questions {\n          margin: 0.55vw 0;\n          border-radius: 2.775vw;\n          gap: 0.6938vw;\n          padding: 0.55vw 3.33vw;\n          border: 1px solid #ffffff;\n          background: #ffffff;\n\n          p {\n            line-height: 1.25vw;\n            font-size: 1.25vw;\n            color: #3f3636;\n            text-align: center;\n            font-weight: 400;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 720px) {\n  .navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper {\n    min-width: none;\n    max-width: none;\n    width: 480px;\n\n    .close .close-icon {\n      width: 30px;\n      height: 30px;\n    }\n\n    .want-to-pay-game-container {\n      h3 {\n        font-size: 20px;\n        line-height: normal;\n      }\n\n      h4,\n      p {\n        font-size: 18px;\n        line-height: normal;\n      }\n      h4 {\n        margin: 15px 0;\n      }\n\n      .navigation-instruction-wrapper input {\n        padding: 10px 15px;\n        font-size: 16px;\n        line-height: 16px;\n        box-sizing: border-box;\n        margin: 15px 0 ;\n      }\n\n      .terms-condition{\n        &>span:last-child{\n          font-size: 12px;\n        }\n      }\n    }\n\n    // .enter-btn {\n    //   margin: 15px 0 30px;\n    // }\n\n    .try-again {\n      margin: 12.5px 0;\n    }\n    button {\n      font-size: 16px;\n      line-height: normal;\n      padding: 10px 15px;\n      border-radius: 2px;\n    }\n\n    p,\n    button {\n      font-size: 16px;\n      line-height: normal;\n    }\n  }\n  .navigation-instruction-dialog\n    .MuiPaper-root.MuiDialog-paper\n    .want-to-pay-game-container\n    .discount-code {\n    font-size: 16px;\n    line-height: 16px;\n    margin: 15px 0;\n  }\n  .navigation-instruction-dialog\n    .MuiPaper-root.MuiDialog-paper\n    .want-to-pay-game-container\n    .code-container\n    p {\n    font-size: 16px;\n    line-height: 16px;\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .navigation-instruction-dialog .MuiPaper-root.MuiDialog-paper {\n    min-width: none;\n    max-width: none;\n    width: 95%;\n    padding: 10px;\n    margin: 0 2.5%;\n  }\n  .navigation-instruction-dialog.isMobile.MuiModal-root\n    .css-19do60a-MuiDialog-container {\n    display: flex !important;\n    align-items: end !important;\n  }\n}\n\n// @keyframes spin{\n//   0% {\n//     transform: rotate(-52.1336deg);\n//   }\n//   100% {\n//       transform: rotate(307.866deg);\n//   }\n// }\n\n// @keyframes continueSpin{\n//   0% {\n//     transform: rotate(-52.1336deg);\n//   }\n//   100% {\n//       transform: rotate(307.866deg);\n//   }\n// }\n\n// @keyframes  stopSpin {\n//   0% {\n//     transform: rotate(-52.1336deg);\n//   }\n//   100% {\n//       transform: rotate(1314.9deg);\n//   }\n// }\n\n// .sc-dlfnbm.started-spinning{\n//   animation: 0.52s cubic-bezier(0.71, -0.29, 0.96, 0.9) 0s 1 normal forwards running spin, 0.15s linear 0.52s 1 normal forwards running continueSpin, 1.6s cubic-bezier(0, 0, 0.35, 1.02) 0.67s 1 normal forwards running stopSpin;\n// }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
